import axios from "axios";
import moment from "moment";
import store from '../store';

const getSession = () => {
	return JSON.parse(localStorage.getItem("vue-session-key"));
};

const httpClient = axios.create({
	baseURL: process.env.VUE_APP_URL,
	withCredentials: true,
	headers:{
		"Access-Control-Allow-Origin":"*",
		"ngrok-skip-browser-warning": "true" // for local testing
	}
});

httpClient.interceptors.request.use(async function (config) {
	const {accessToken, atoken_expire_time, rtoken_expire_time} = getSession();
	const accessTokenExpire = moment(atoken_expire_time).diff(moment(), "hours") <= 0;
	const refreshTokenExpire = moment(rtoken_expire_time).diff(moment(), "hours") <= 0;
	if (!accessTokenExpire) {
		config.headers['Authorization'] = `Bearer ${accessToken}`;
	} else if (accessTokenExpire && !refreshTokenExpire) {
		await store.dispatch("refreshAccessToken");
		config.headers['Authorization'] = `Bearer ${getSession().accessToken}`;
	}
	return config;
});

function setErrorInformation({statusCode=null, message='', dialogStatus=true, btnText="OK"}){
	store.commit("error/setErrorStatusCode", statusCode);
	store.commit("error/setErrorDialogMessage", message);
	store.commit("error/setErrorDialogStatus", dialogStatus);
	store.commit("error/setErrorBtnText", btnText);
}

httpClient.interceptors.response.use(function (response) {
	return response;
}, function (error) {
	let{status, data} = error.response;

	if (!error.response) {
		console.log("NO RESPONSE");
		setErrorInformation({
			statusCode:status,
			message:"Insights Can't Connect to Server.Please Check Connection and Try Again."
		});
		return Promise.reject(error);
	}
	switch (status) {
		case 401:
			console.log("CASE 401");
			if(data === 'Unauthorized'){
				setErrorInformation({
					statusCode:status,
					message:"Session Expired. Please Login Again.",
				});
			}else if(data.expired){
				store.commit("error/setOrganizationExpiredStatus", true);
				store.commit("error/setOrganizationExpiredMessage", data.error);
			}
			break;
		case 500:
			console.log("CASE 500");
			setErrorInformation({
				statusCode:status,
				message:"Sorry, There is Something Wrong with this monitor.Server can't response.",
				btnText:"Back To Monitor List"
			});
			break;
		case 422:
			console.log("CASE 422");
			let errors = data ? data.errors && Object.values(data.errors) || [] : [];
			// let errors = data && Object.values(data.errors) || [];
			setErrorInformation({
				statusCode:status,
				message:errors.join(".")
			});
			break;
		default:
			console.log("CASE DEFAULT");
			setErrorInformation({
				statusCode:status,
				message:"Sorry, server is busy.Can't response your request."
			});
	}
	return Promise.reject(error);
});


export default httpClient;
